export const plants = (state) => {
  return state.plants;
};

export const life = (state) => {
  return state.life;
};

export const activePage = (state) => {
  return state.activePage;
};

export const difficulty = (state) => {
  return state.difficulty;
};

export const family = (state) => {
  return state.family;
};

export const game = (state) => {
  return state.game;
};

export const score = (state) => {
  return state.score;
};
